import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Insurance, InsuranceStatus } from 'src/app/core/models';
import { FetchPatientInsuranceCards } from 'src/app/core/store/patient-insurances/patient-insurances.actions';
import { PatientInsurancesState } from 'src/app/core/store/patient-insurances/patient-insurances.state';
import { ApiStoreData } from 'src/app/core/store/utils';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss'],
})
export class InsuranceComponent implements OnInit {
  @Select(PatientInsurancesState.patientInsuranceCardsState) patientInsuranceCardsState$!: Observable<
    ApiStoreData<Insurance[]>
  >;

  displayModal: boolean = false;

  constructor(private store: Store) {}

  ngOnInit() {
    this.store.dispatch(new FetchPatientInsuranceCards());
  }

  showModal() {
    this.displayModal = true;
  }

  hideModal() {
    this.displayModal = false;
  }

  getInsuranceStatusSeverity(status: InsuranceStatus): string {
    return status === InsuranceStatus.Active ? 'success' : InsuranceStatus.Pending ? 'warning' : '';
  }
}
